import Bone from '../Bone';
import { StyledLeadManagementSkeletonWrapper, StyledSkeletonWrapper } from './StyledComponents';

export const ConversationSearchBarSkeleton = () => {
  return (
    <StyledSkeletonWrapper>
      <Bone dark={true} type="badge" />
    </StyledSkeletonWrapper>
  );
};

export const LeadManagementConversationSearchBarSkeleton = () => {
  return (
    <StyledLeadManagementSkeletonWrapper>
      <Bone dark={true} type="line" />
    </StyledLeadManagementSkeletonWrapper>
  );
};
